import useCasesData from '~/content/case-study/useCases'
import { hasCaseContentPageConfig } from '~/utils/case-content-page-config'

export const VALID_CASE_IDS = useCasesData.map((uc) => uc.id)

/** Vue Router path param regex: only known case study slugs */
export const CASE_ROUTE_PARAM_PATTERN = VALID_CASE_IDS.join('|')

export function isValidCaseId(caseId: unknown): boolean {
    return typeof caseId === 'string' && VALID_CASE_IDS.includes(caseId)
}

export function isValidCaseContentRoute(caseId: unknown, contentId: unknown): boolean {
    if (typeof caseId !== 'string' || typeof contentId !== 'string') {
        return false
    }
    return hasCaseContentPageConfig(`${caseId}/${contentId}`)
}
